<template>
    <auto-row class="wrap" mode="column">
        <auto-col>
            <head-nav @change="navChange"></head-nav>
        </auto-col>
        <auto-col class="page-top">
            <div class="banner-box" ref="eLocation">
                <img src="@/assets/image/aboutUs/04/00 banner.png" class="max-size" data-fit-cover alt=""  />
            </div>
        </auto-col>
        <auto-col style="background-color:#fff; border-bottom:1px solid #C7C7C7;">
            <location class="content-w" :data="currentNav.pathArr || []"></location>
        </auto-col>
        <auto-col  class="page-content" size="auto">
            <div class="x-w page-content-child">
                <div class="content-w">
                    <div class="page-content-box">
                        <div class="x-w-content">
                            <h2 class="page-content-title">{{ detail.title }}</h2>
                            <div style="text-align:center; max-width:1100px; margin:0 auto 20px;">
                                <span style="color:#888; font-size:16px; margin:0 10px;" v-if="detail.date">发布时间：{{ detail.date }}</span>
                                <span style="color:#888; font-size:16px; margin:0 10px;" v-if="detail.orange">来源：{{ detail.orange }}</span>
                            </div>
                            <div class="rich_text" style="border-top:1px solid #DFDFDF;">
                                <div v-html="detail.content"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
<!--            <div class="page-content-child"-->
<!--                v-for="(src,i) of imgArr"-->
<!--                :key="i"-->
<!--            >-->
<!--                <div class="content-w">-->
<!--                    <img :src="src" width="100%" alt="" />-->
<!--                </div>-->
<!--            </div>-->
        </auto-col>
        <auto-col>
            <form-box></form-box>
            <footer-box></footer-box>
            <fixed-box></fixed-box>
        </auto-col>
    </auto-row>
</template>

<script>
    import {
        autoRow,
        autoCol
    } from "@/components"
    import headNav from "@/components/headNav"
    import formBox from "@/components/formBox"
    import footerBox from "@/components/footerBox"
    import fixedBox from "@/components/fixedBox"
    import location from "@/components/location"
    import {
        methods
    } from "@/mixins"
    import {x_w_List} from "../../assets/js/news";
    export default {
        name: '',
        components: {
            autoRow,
            autoCol,
            headNav,
            formBox,
            footerBox,
            fixedBox,
            location,
        },
        mixins:[methods],
        props: [],
        data() {
            return {
                currentNav:{},
                imgArr:[
                    require('@/assets/image/aboutUs/04/pic-1.png'),
                    require('@/assets/image/aboutUs/04/pic-2.png'),
                ],
                detail: {},
                list:[

                ]
            }
        },
        computed: { //计算属性

        },
        watch: {  //监听器

        },
        methods: {
            navChange(nav){
                this.currentNav = nav;
            }
        },
        created(){
            this.list = x_w_List
            const idx = this.list.map(n => n.id).indexOf(parseInt(this.$route.query.id))
            this.detail = this.list[idx]
        }, //组件实例创建完成，属性已绑定，但DOM还未生成，属性还不存在
        mounted(){
            this.$refs.eLocation && this.toScrollTop(this.$refs.eLocation.offsetTop);
        }, //模板编译/挂载之后(不保证组件已在document中)
        beforeRouteLeave(to, from, next) {
            next();
        },
//        beforeCreate(){}, //组件实例刚被创建，组件属性计算之前，如data属性等
//        beforeMount(){}, //模板编译/挂载之前
//        beforeUpdate(){}, //组件更新之前
//        updated(){}, //组件更新之后
//        activated(){}, //for keep-alive,组件被激活时调用
//        deactivated(){}, //for keep-alive,组件被激活时调用
//        beforeDestory(){}, //组件销毁前调用
//        destoryed(){}, //组件销毁后调用
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .wrap{
        background-color:#f0f2f5;
        min-height:100vh;
    }
    .banner-box{
        position:relative;
    }
    .banner-box img{
        width:100%;
        max-height:600px;
        min-height:200px;
        overflow:hidden;
        vertical-align: middle;
    }
    .page-content{
        position: relative;
        z-index:2;
    }
    .page-content-child:nth-child(1){
        background-color: #FFFFFF;
    }

    .page-content-child .title:nth-child(1){
        color:#333333;
        font-size: 36px;
        line-height: 1;
        letter-spacing: 16px;
    }

    .page-content-box{
        overflow:hidden;
    }

    .x-w .x-w-content{
        text-align: center;
        padding:102px 0 53px 0;
    }

    .page-content-title{
        text-align:center;
        font-weight: 400;
        font-size:30px;
        color:#333;
        position:relative;
        padding:30px 20px 40px;
        background-color:#fff;
        letter-spacing: 6px;
        max-width:1100px;
        margin:auto;
    }

    .rich_text{
        min-height:500px;
        padding-top:60px;
        padding-bottom:100px;
        max-width:1100px;
        margin:auto;
        overflow-x:auto;
    }

    /deep/.b12c {
        font-size: 16px!important;
        line-height: 180%!important;
    }

    /*适配不同尺寸*/
    @media screen and (max-width: 1540px){


    }

    @media screen and (max-width: 1200px){
        .x-w-media{
            display: flex;
            flex-flow: column nowrap!important;
            align-items:flex-start!important;
        }

        .list-item{
            transition: all .3s;
            padding:40px 40px;
            position: relative;
        }

        .list-item:nth-child(1){
            margin-top: 55px;
        }

        .x-w-img{
            max-width: 100%;
            height: 100%;
            background: #D8D8D8;
            border: 1px solid #979797;
        }

        .x-w-infos{
            text-align: left;
            margin-left:0!important;
            padding-right:90px;
        }

        .x-w-infos{
            text-align: left;
            margin-left:32px;
            padding-right:50px;
            position: relative;
        }

        .x-w-infos .x-w-arrow{
            position: absolute;
            top:0;
            bottom:0;
            margin: auto 0;
            right:0px;
            width: 40px;
            height: 56px;
            background: #2FA8D0;
        }

    }


    @media screen and (max-width: 960px){
        .x-w .x-w-content{
            text-align: center;
            padding:50px 0 45px 0;
        }
        .list-item{
            transition: all .3s;
            padding:30px 30px;
            position: relative;
        }

        .list-item:nth-child(1){
            margin-top: 55px;
        }
    }

    @media screen and (max-width: 760px){

        .x-w .x-w-content{
            text-align: center;
            padding:40px 0 45px 0;
        }

        .list-item{
            transition: all .3s;
            padding:20px 20px;
            position: relative;
        }

        .list-item:nth-child(1){
            margin-top: 25px;
        }

        .x-w-infos .items{
            font-size: 20px;
            font-weight: 400;
            color: #888888;
            line-height: 1;
            padding-top:18px;
            display: flex;
            flex-flow: column nowrap;
        }

        .x-w-infos .items .item{
            width: 100%;
            text-align: left;
        }

        .x-w-infos .items .item:last-child{
            padding-top:10px;
        }
    }
</style>
